import { Typography } from "@mui/material"

export function AuthoringHomeTitlePlugin() {
    return (
        <Typography variant="h4" gutterBottom data-cy="authoring-home-title">
            SFG20 Authoring
        </Typography>
    )
}
